import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema, defaultObject} from '/vercel/path0/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/markdoc/tags.js'
import * as nodes from '/vercel/path0/markdoc/nodes/index.js'
const functions = {};
const schema = {
tags: defaultObject(tags),
nodes: defaultObject(nodes),
functions: defaultObject(functions),
...defaultObject(config),
};

const tokenizer = new Markdoc.Tokenizer();

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ndescription: Documentation of the geOps Routing API. With our routing service you can find the routes and lines for public\n  transport vehicles, for cars and trucks as well as for pedestrians.\nicon: path\ntitle: Routing\nsubtitle: Public transport and pedestrian routing\nswagger: /swagger/routing.json\nweight: 1\n---\n\nThis API allows to get precise geographic routes for various modes of public transport.\n\nIn order to define the route you may pass names and IDs for stations or geographic coordinates. Routing can be based on different networks. While OpenStreetMap is the most common one and the one with most details in it, we also provide additional datasets that are optimized for maps of smaller scales.\n\nThe routing for MOTs of public transport uses an [algorithm by Bast & Brosi (2018)](http://ad-publications.informatik.uni-freiburg.de/SIGSPATIAL_Sparse%20map%20matching%202018.pdf) that has been adapted to our needs. \nFor pedestrian routing we use our own algorithm with contraction hierarchies for best results inside of stations and very quick response times.\nWe have added routing for cars and trucks from [Graphhopper](https://www.graphhopper.com/). In order to achieve the best possible results all base data like the underlying networks or the dataset of stations undergo continuous quality control and improvements.\n\nFor more ideas please check our [demo](https://routing-demo.geops.io/) or example implementations in the {% link href=\"/guides\" %}guides{% /link %} section.\n";
const filepath = "/apis/routing.md";
const tokens = tokenizer.tokenize(source);
const ast = Markdoc.parse(tokens);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    const tokens = tokenizer.tokenize(partials[key]);
    partials[key] = Markdoc.parse(tokens);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = await Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
